import eventBus from "../services/event-bus";
import { elementExists } from "../utils";

const CartCount = function ($selector) {
  const _this = {};

  _this.classes = {
    empty: 'empty'
  }

  _this.elements = document.querySelectorAll($selector);

  if (elementExists(_this.elements)) {
    eventBus.on(eventBus.types.CartUpdated, (event) => {
      _this.elements.forEach(el => el.innerText = Shopify.cartService.cart.item_count);
    });
  }
}

export default CartCount;

